import * as React from "react";
import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { IllumaWhiteLogo } from "../../../assets/icons/IllumaWhiteLogo";

import { SettingsNavBar } from "./SettingsNavBar";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../../../lib/cache";
import { BiChevronDown } from "react-icons/bi";

export const SideNavBar: React.FC = ({ children }) => {
  const currentUser = useReactiveVar(userDetailsVar);

  return (
    <Flex
      display="flex"
      direction="column"
      bg={"tertiary.dark"}
      // w={{ base: 'full', md: 80 }}
      w={"19rem"}
      h={"100%"}
      ml={0}
    >
      {currentUser?.isStaff ?
        <Menu variant={"settingsMenu"}>
          <MenuButton
            as={Button}
            variant={"accountMenu"}
            height={"auto"}
            rightIcon={<Icon as={BiChevronDown} />}
            color={"white"}
            fontWeight={"bold"}
            fontSize={"25px" }
            w={"80%"}
            mt={8}
            mb={5}
            px={2}
            alignSelf={"center"}
            textAlign={"left"}
          >
            illuma UI
          </MenuButton>
          <MenuList>
            <Link to={"/campaigns"}>
              <MenuItem value="buyer">
                Buyer
              </MenuItem>
            </Link>
            <Link to={"/publisher"}>
              <MenuItem value="publisher">
                Publisher
              </MenuItem>
            </Link>
          </MenuList>
        </Menu>
        :
        <Link to={"/"}>
          <Text
            color="white"
            fontWeight="bold"
            fontSize="25px"
            ml={6}
            mt={8}
            mb={5}
          >
            {"illuma UI"}
          </Text>
        </Link>
      }
      <Box width={"80%"} mx={"auto"}>
        {children}
      </Box>

      <Flex
        alignSelf="flex-end"
        mx="auto"
        justifyContent="center"
        py={4}
        marginTop="auto"
        mb={5}
        direction="column"
        width="100%"
      >
        <SettingsNavBar />
        <Divider
          alignSelf="flex-end"
          width={"85%"}
          marginTop={"4"}
          mx="auto"
          borderColor={"muted"}
          mb={5}
        />

        <HStack
          ml={3}
          spacing={0}
          alignItems="center"
          justifyContent={"center"}
          width={"85%"}
        >
          <Text color="muted" fontSize="13px">
            {"By "}{" "}
          </Text>
          <Link to={"/"}>
            <IllumaWhiteLogo w={32} h={6} />
          </Link>
          <Text fontSize="13px" color="muted">
            {" "}
            Technology{" "}
          </Text>
        </HStack>
      </Flex>
    </Flex>
  );
};
